import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnInit,
    ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-segmented-control',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './segmented-control.component.html',
    styleUrl: './segmented-control.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SegmentedControlComponent implements OnInit {
    @Input() labels: string[] = [];
    @Input() selectedLabel: string = '';

    @Output() selectionChange = new EventEmitter<string>();

    ngOnInit(): void {
        // Select the first label by default if none is selected
        if (this.labels.length > 0 && !this.selectedLabel) {
            this.selectedLabel = this.labels[0];
        }
    }

    onSegmentClick(label: string): void {
        if (this.selectedLabel !== label) {
            this.selectedLabel = label;
            this.selectionChange.emit(label);
        }
    }

    isSelected(label: string): boolean {
        return this.selectedLabel === label;
    }

    trackByLabel(index: number, label: string): string {
        return label;
    }

    getTestAttribute(label: string): string {
        return 'segment-' + label.toLowerCase().replace(/\s+/g, '-');
    }
}
